import { Polyline } from 'react-leaflet';
import { ICoordinate } from '../../../../../../../../../models/coordinate.model';
import Colors from '../../../../../../../../../helpers/colors.helper';

function NonPublicTransportPolyline({ coordinates }: { coordinates: ICoordinate[] }) {
  return <Polyline positions={coordinates.map((c) => [c.latitude, c.longitude])} weight={10} color={Colors.vtdGray900} dashArray={[1, 16]} lineJoin="round" interactive={false} />;
}

export default NonPublicTransportPolyline;
